import {
  Group,
  GroupItem,
  GroupTitle,
  LongTextField,
  useFieldLabel,
} from "ra-friendsofbabba";
import React from "react";
import {
  Datagrid,
  DateField,
  Pagination,
  ReferenceManyField,
  TextField,
  useTranslate,
} from "react-admin";

const PaginationWrapper = ({ fullWidth, addLabel, ...props }) => (
  <Pagination {...props} />
);

const UserLogsField = (props) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel(props);
  return (
    <Group wrapper>
      <GroupTitle title={translate(fieldLabel("user_logs"))} />
      <Group>
        <GroupItem lg={12} md={12} sm={12}>
          <ReferenceManyField
            {...props}
            perPage={5}
            pagination={<PaginationWrapper />}
            reference={"user-logs"}
            target="user_id"
            sort={{ field: "created", order: "DESC" }}
          >
            <Datagrid>
              <TextField source="id" />
              <TextField source="ip_address" />
              <LongTextField source="user_agent" maxWidth={450} />
              <DateField source="created" showTime />
            </Datagrid>
          </ReferenceManyField>
        </GroupItem>
      </Group>
    </Group>
  );
};
export default UserLogsField;
